import React, { useState,useEffect } from "react";
import RestaurantsFavoritesInsidePage from "./FavoritesPageInsideComponent/RestaurantsFavoritesInsidePage";
import OffersFavoritesInsidePage from "./FavoritesPageInsideComponent/OffersFavoritesInsidePage";
import EventsFavoritesInsidePage from "./FavoritesPageInsideComponent/EventsFavoritesInsidePage";
import ItemFavoritesInsidePage from "./FavoritesPageInsideComponent/ItemFavoritesInsidePage";
import { Button } from "react-bootstrap";

const FavoritesPageComponent = (props) => {
  let filteredData = props.data;

  if (props.search) {
    filteredData = filteredData.filter((item) => {
      return (
        item?.restaurant_id?.restaurant_name
          .toLowerCase()
          .includes(props.search.toLowerCase()) ||
        item?.offerId?.name
          .toLowerCase()
          .includes(props.search.toLowerCase()) ||
        item?.eventId?.name
          .toLowerCase()
          .includes(props.search.toLowerCase()) ||
        item?.itemId?.name.toLowerCase().includes(props.search.toLowerCase()) ||
        item?.eventId?.restaurant_id?.restaurant_name
          .toLowerCase()
          .includes(props.search.toLowerCase())
      );
    });
  }

  if (props.sortBy === "Latest") {
    filteredData = filteredData?.sort(
      (a, b) => new Date(b.updatedAt) - new Date(a.updatedAt)
    );
  } else if (props.sortBy === "Oldest") {
    filteredData = filteredData?.sort(
      (a, b) => new Date(a.updatedAt) - new Date(b.updatedAt)
    );
  }

  const restFav = filteredData?.filter((e) => e?.activity_type === "2");
  const offerFav = filteredData?.filter((e) => e?.activity_type === "3");
  const eventFav = filteredData?.filter((e) => e?.activity_type === "4");
  const itemFav = filteredData?.filter((e) => e?.activity_type === "5");
  const [insidePageTab, setInsidePageTab] = useState("1");

  const pageChangeButtonClickHandler = (value) => (e) => {
    setInsidePageTab(value);
  };

  useEffect(() => {
    props.setInsidePageFav(insidePageTab);
  }, [insidePageTab]);

  return (
    <React.Fragment>
      <div className="row super_admin_all_users_toggle_button-tab">
        <div className="col-9 super_admin_all_users_toggle_button-tab">
          <div className="Right-side-heading-text ml-0">
            <div className="d-flex align-items-center">
              <Button
                variant="link"
                className={`px-0 mr-4 text-grayLink f12-500 ${
                  insidePageTab === "1" ? "active" : ""
                }`}
                onClick={pageChangeButtonClickHandler("1")}
              >
                Restaurants
              </Button>
              <Button
                variant="link"
                className={`px-0 mr-4 text-grayLink f12-500 ${
                  insidePageTab === "2" ? "active" : ""
                }`}
                onClick={pageChangeButtonClickHandler("2")}
              >
                Offers
              </Button>
              <Button
                variant="link"
                className={`px-0 mr-4 text-grayLink f12-500 ${
                  insidePageTab === "3" ? "active" : ""
                }`}
                onClick={pageChangeButtonClickHandler("3")}
              >
                Experience
              </Button>
              <Button
                variant="link"
                className={`px-0 mr-4 text-grayLink f12-500 ${
                  insidePageTab === "4" ? "active" : ""
                }`}
                onClick={pageChangeButtonClickHandler("4")}
              >
                Items
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className="col-12 p-0">
        {insidePageTab === "1" && (
          <RestaurantsFavoritesInsidePage
            data={restFav}
            insidePageTab={insidePageTab}
            clickedSearch={props.clickedSearch}
            sortByDate={props.sortByDate}
            search={props.search}
            startDay={props.startDay}
            endDay={props.endDay}
            sortByDay={props.sortByDay}
            favouriteFilter={props.favouriteFilter}
            startDate={props.startDate}
            endDate={props.endDate}
          />
        )}
        {insidePageTab === "2" && (
          <OffersFavoritesInsidePage
            allOffers={offerFav}
            insidePageTab={insidePageTab}
          />
        )}
        {insidePageTab === "3" && (
          <EventsFavoritesInsidePage
            allEvents={eventFav}
            insidePageTab={insidePageTab}
          />
        )}
        {insidePageTab === "4" && (
          <ItemFavoritesInsidePage
            allItems={itemFav}
            insidePageTab={insidePageTab}
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default FavoritesPageComponent;
